/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { CTAs, Button } from '@insticator/insticator-ui'; // iui-material
import SectionDescription from '../../../../../../material/expandablesection/sectiondescription/sectiondescription';
// utils
import { url } from '../../../../../../utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from './marketing_styles';



/* ========== ~~~~~~~~~~ MARKETING PAGE - SENTIMENT ~~~~~~~~~~ ========== */
const MarketingPage = injectSheet(styles)((props) => {
  return (
    <div className={`marketingpage ${props.classes.marketing}`}>
      <div className={'content'}>
        <div className={'desc'}>
          <h2>Increase the Engagement of <span className={'clump'}>Your Visitors</span></h2>
          <h3>Get your visitors spending more time on your site while gathering trends of their interests</h3>
          {/*<h4>Article Sentiment</h4>*/}
          <p>Your visitors can vote and immediately react to the articles they just read. Include up to 8 emoji reactions to gauge their overal sentiment. Compare that article’s sentiment across all other articles on your site for a specified time period.</p>
          <CTAs>
            {/*<Button name={'cancel'} type={'action'} variant={'system'} text={'Cancel'} icon={''} action={props.onCancel} />*/}
            <Button name={'requestaccess'} type={'action'} variant={'primary'} text={'Request Access'} icon={'unlock-alt'} action={props.onRequest} iconRight={true} />
          </CTAs>
        </div>
        <div className={'graphic'}>
          <img src={`${url.image}/2.0/marketingpages/product-sentiment-thumb.png`} />
        </div>
      </div>
    </div>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MarketingPage;

